const getFacetLink = (canonicalUrl, option) => {
  const { facetType, facetValue } = option;
  const [linkWithoutQuery] = canonicalUrl.split('?');
  const queryString = `${encodeURIComponent(facetType)}=${encodeURIComponent(facetValue)}`;
  return `${linkWithoutQuery}?${queryString}`;
};

export { getFacetLink };
